<script setup lang="ts">
import type { RouteLocationRaw } from 'vue-router';

const props = withDefaults(defineProps<{
  to: RouteLocationRaw;
  replace?: boolean;
  message?: string;
}>(), {
  replace: false,
  message: 'Redirecting...',
});

navigateTo(props.to, { replace: props.replace });
</script>

<template>
  <div class="p-4 text-center">
    {{ message }}
  </div>
</template>
